var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"has-text-weight-bold is-uppercase is-size-7"},[_vm._v("Project Health")]),_c('div',[_c('BurnLineChart',{attrs:{"project":_vm.project,"stage":'billable',"height":136}})],1),_c('div',[_c('BurnBarChart',{attrs:{"project":_vm.project,"stage":'billable',"height":64}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }